import _ from 'lodash'
import api from '../../api'
import * as types from '../mutation-types'

// initial state
const state = {
  menus: [],
  spots: {
    items: []
  },
  tours: {
    items: []
  },
  keywords: [],
  locations: [],
  loaded: false
}

// getters
const getters = {
  getMenus: state => state.menus,
  getAllSpots: state => state.spots,
  getAllTours: state => state.tours,
  getAllKeywords: state => state.keywords,
  getAllLocations: state => state.locations,
  isListLoaded: state => state.loaded,
}

// actions
const actions = {

  fetchSnippets ({ commit }, { ep, lang }) {
    api.fetchSnippets(ep, lang, res => {
      if(ep == 'menus'){
        commit(types.STORE_FETCHED_MENUS, { res })
      } else if (ep == 'keywords') {
        commit(types.STORE_FETCHED_KEYWORDS, { res })
      } else if (ep == 'locations') {
        commit(types.STORE_FETCHED_LOCATIONS, { res })
      }
      commit(types.INCREMENT_LOADING_PROGRESS)
    })
  },

  fetchSpotList ({ commit }, { lang }) {
    commit(types.LIST_LOADED, false)
    api.fetchSpotList(lang, list => {
      commit(types.STORE_FETCHED_SPOT_LIST, { list })
      commit(types.STORE_KEYWORD_SPOT_LIST)
      commit(types.STORE_LOCATION_SPOT_LIST)
      commit(types.LIST_LOADED, true)
      commit(types.INCREMENT_LOADING_PROGRESS)
    })
  },

  fetchTourList ({ commit }, { lang }) {
    commit(types.LIST_LOADED, false)
    api.fetchTourList(lang, list => {
      commit(types.STORE_FETCHED_TOUR_LIST, { list })
      commit(types.LIST_LOADED, true)
      commit(types.INCREMENT_LOADING_PROGRESS)
    })
  },

  setKeywordList  ({ commit }) {
    commit(types.STORE_KEYWORD_SPOT_LIST)
  },

  setLocationList  ({ commit }) {
    commit(types.STORE_LOCATION_SPOT_LIST)
  },
}

// mutations
const mutations = {

  [types.STORE_FETCHED_MENUS] (state, { res }) {
    state.menus = res
  },

  [types.STORE_FETCHED_SPOT_LIST] (state, { list }) {
    state.spots = list
  },

  [types.STORE_FETCHED_TOUR_LIST] (state, { list }) {
    state.tours = list
  },

  [types.STORE_KEYWORD_SPOT_LIST] (state) {
    state.loaded = false
    let items = {}
    for (const spot of state.spots.items) {
      for (const keyword of spot.keywords) {
        if (Object.prototype.hasOwnProperty.call(items, keyword.spot_keyword.keyword)) {
          items[keyword.spot_keyword.keyword]['items'].push(spot)
        }else{
          const keyObj = keyword.spot_keyword
          items[keyObj.keyword] = { 'items': new Array(spot) }
          items[keyObj.keyword]['title'] = keyObj.keyword
          items[keyObj.keyword]['slug'] = keyObj.slug
          items[keyObj.keyword]['ordering'] = keyObj.ordering
        }
      }
    }
    state.keywords = _.orderBy(items, 'ordering', 'asc')
    state.loaded = true
  },

  [types.STORE_LOCATION_SPOT_LIST] (state) {
    state.loaded = false
    let items = {}
    for (const spot of state.spots.items) {
      for (const location of spot.locations) {
        if (Object.prototype.hasOwnProperty.call(items, location.spot_location.name)) {
          items[location.spot_location.name]['items'].push(spot)
        }else{
          const locObj = location.spot_location
          items[locObj.name] = { 'items': new Array(spot) }
          items[locObj.name]['title'] = locObj.name
          items[locObj.name]['slug'] = locObj.slug
          items[locObj.name]['ordering'] = locObj.ordering
        }
      }
    }
    state.locations = _.orderBy(items, 'ordering', 'asc')
    state.loaded = true
  },

  [types.LIST_LOADED] (state, bool) {
    state.loaded = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
